import { CartComponent } from './cart/CartComponent';
import { WineInfo } from './WineInfo';
import useMouse from './hooks/useMouse';
import { WineWidgetModel } from '../../models/WineWidgetModel';
import { WineTags } from './components/WineTags';
import { DiscountTag } from './components/DiscountTag';
import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';
import { useCalculatedDiscount } from 'shared-widget-components/src/hooks/useCalculatedDiscount';
import { useWineClasses } from './hooks/useWineClasses';
import { useOnWineClick } from './hooks/useOnWineClick';

interface WineProps {
  wine: WineWidgetModel;
  //drag and drop komponensben false, previewben true
  isShowCart: boolean;
}

/**
 * The Wine component renders a wine card with the wine image, title, manufacturer name, price, and discount.
 * @param wine - The wine object.
 * @param isShowCart - A boolean value that determines whether the cart component is visible or not
 * @returns a JSX fragment. It is rendering the wine card with the wine image, title, manufacturer name, price, and discount
 */

export const Wine = ({ wine, isShowCart }: WineProps) => {
  const { isCartVisible, handleMouseEnter, handleMouseLeave } = useMouse(isShowCart);

  const { onWineClick } = useOnWineClick(wine);

  const { slideUpDivClasses, classnameWithCart, classnameWithoutCart } = useWineClasses(wine.showEurPrice);

  const basePrice = wine.basePrice!;
  const currentPrice = wine.currentPrice!;

  const { calculatedDiscount } = useCalculatedDiscount({ basePrice, currentPrice });

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`relative w-[310px] ${wine.showEurPrice ? 'min-[350px]:h-[415px] md:h-[430px]' : 'min-[350px]:h-[400px] md:h-[410px]'} lg:h-[330px] overflow-hidden bg-[#F6F5F2] rounded py-[8px] px-3`}
    >
      <WineTags wine={wine} />
      <DiscountTag discount={calculatedDiscount} isManufacturer={wine.isManufacturer} />
      {wine.isManufacturer && ( // if we are on a merchant site, we display the manufacturers name
        <>
          <h3 className='font-semibold text-[13px] font-body truncate mb-[4px] uppercase'>{wine.manufacturerName}</h3>
          <div className='divider w-full h-[1px] bg-slate-200'></div>
        </>
      )}
      <CDNImage fit='crop' imageHeight={250} className='cursor-pointer mx-auto' alt={wine.imgUrl} src={wine.imgUrl} onClick={onWineClick} />
      <div className={`${slideUpDivClasses} ${isCartVisible ? classnameWithCart : classnameWithoutCart}`}>
        <WineInfo wine={wine} />
        <CartComponent wine={wine} />
      </div>
    </div>
  );
};
